import { SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';
import { CopilotImportStrategy } from '../CopilotSetting.types';
import { useMemo } from 'react';
import { omit } from 'lodash';

interface UseCopilotImportStrategySettingProps {
  sensorAuthId: number | undefined;
}

interface CopilotImportStrategySetting {
  value: CopilotImportStrategy | undefined;
  onSave: (payload: CopilotImportStrategy) => Promise<void>;
}

const SETTING_NAME = SettingValues.COPILOT_AI_METRICS_IMPORT_STRATEGY;

const useCopilotImportStrategySetting = ({
  sensorAuthId
}: UseCopilotImportStrategySettingProps): CopilotImportStrategySetting => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();

  const setting = getSettingOrDefinitionValue({
    name: SETTING_NAME
  });

  const value = useMemo(() => {
    return setting?.[sensorAuthId];
  }, [setting, sensorAuthId]);

  const onSave = async (payload: CopilotImportStrategy) => {
    const updatedSetting = {
      ...setting,
      [sensorAuthId]: payload
    };
    const settingPayload = omit(updatedSetting, 'default');
    await updateSetting(SETTING_NAME, settingPayload);
  };

  return {
    value,
    onSave
  };
};

export default useCopilotImportStrategySetting;
